import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { RemoteAction } from '../../remote-action';
import { AppService } from 'src/app/_services/app-service/logic/app.service';
import { CredentialsService } from 'src/app/_services/credentials/logic/credentials.service';
import { ServiceRemoteActionBuilder } from '../service-remote-action-builder';
import { ExtFile } from 'src/app/_model/ext-file';
import { max } from 'date-fns';

export class ExtFileRemoteActionBuilder extends ServiceRemoteActionBuilder {
  constructor(
    extFile: ExtFile | number,
    appService: AppService,
    private credentialsService: CredentialsService,
    private logger?: LoggingService,
    maxWidth?: number,
    maxHeight?: number,
  ) {
    super(
      appService,
      credentialsService,
      {
        endpoint:
          'downloadextfile/' +
          (typeof extFile == 'number' ? extFile : extFile.id.imsId),
        data: {
          extFileId: typeof extFile == 'number' ? extFile : extFile.id.imsId,
          maxwidth: maxWidth,
          maxheight: maxHeight,
        },
        cachable: false,
        fifo: false,
        authenticationRequired: true,
      },
      [],
      async (_data: any) => {},
      logger
    );
  }

  public async next(dataValues?: { key: string; value: any }[]): Promise<any> {
    return super.next(dataValues);
  }

  public async generateRemoteAction(
    dataValues: { key: string; value: any }[]
  ): Promise<RemoteAction> {
    let ra = await super.generateRemoteAction(dataValues);
    if (ra.data['objId'] && ra.timestamp) {
      ra.data['id'] =
        ra.data['objId'] +
        this.credentialsService.credentials$.getValue().username +
        ra.timestamp +
        '_' +
        0; // TODO: Hardcoded zero. If the meaning of this value can be pinned down update.
    }
    return ra;
  }
}
